define('features/overlayGameLauncher/stats/xp/xpViewModel',[
    'knockout',
    'underscore'
],
function (ko, _) {

    return function XPViewModel (newAdventure, adventureStaticData, parentView, id) {

        var self = this;

        self.id = id || 'xp';
        self.xp = newAdventure.summary.property('xp');

        self.viewSmall = 'features/overlayGameLauncher/stats/xp/xpViewSmall';
        self.viewLarge = 'features/overlayGameLauncher/stats/xp/xpViewLarge';

        self.cssBinding = ko.pureComputed(function () {
            var currentBelt = self.belt(),
                css = {};

            _.set(css, 'color-' + self.belts[currentBelt].color, true);

            return css;
        });

        self.viewBeltInfo = ko.observable(false);

        self.activate = function () {
            self.viewBeltInfo(false);
        };

        adventureStaticData.apply(this, []);

    };
});

